export enum EViews {
  CASES = "CASES",
  ACTIONS = "ACTIONS",
  CLIENTS = "CLIENTS",
  LETTERS = "LETTERS",
  PACKAGES_INCOMING = "PACKAGES_INCOMING",
  PACKAGES_OUTCOMING = "PACKAGES_OUTCOMING",
  TEMPLATES = "TEMPLATES",
  INVOICES = "INVOICES",
  ENGAGEMENTS = "ENGAGEMENTS",
}
